import { ReactNode, useState } from 'react';
import { attempt } from 'yoso';
import { AccordionContext, AccordionContextValue } from '../Accordion.hooks';

export type AccordionRootProps = {
  active?: boolean;
  children?: ReactNode | ((value: AccordionContextValue) => ReactNode);
} & JSX.IntrinsicElements['div'];
export const AccordionRoot = ({ active: activeProp, children, ...props }: AccordionRootProps) => {
  const stateless = activeProp !== undefined;
  const [active, setActive] = useState(activeProp || false);
  const value = stateless
    ? { active: activeProp || false, setActive: () => false }
    : {
        active,
        setActive,
      };
  return (
    <AccordionContext.Provider value={value}>
      <div {...props}>{attempt(children, value)}</div>
    </AccordionContext.Provider>
  );
};
